<template>
    <div class="market" v-loading="loading">
        <div class="market-block">
            <div class="market-first">
                <div class="market-first-top">
                    <div class="top-list" v-for="(item, index) in marketTitleArray" :key="index"
                        :class="{ active: marketTitleIndex == index }" @click="titleBtn(index)">
                        <div class="top-list-title">{{ item }}</div>
                        <div class="top-list-lint" v-if="marketTitleIndex == index"></div>
                    </div>
                </div>

                <div class="market-first-center">
                    <div class="first-center-list" v-for="(item, index) in 8" :key="index">
                        <div class="first-center-list-title">
                            {{
                                index == 0
                                ? '商品id'
                                : index == 1
                                    ? '商品名称'
                                    : index == 2
                                        ? '商品编号'
                                        : index == 3
                                            ? '产地'
                                            : index == 4
                                                ? '供应商名称'
                                                : index == 5
                                                    ? '品牌'
                                                    : index == 6
                                                        ? '状态'
                                                        : ''
                            }}
                        </div>

                        <div class="first-center-list-input">
                            <el-input v-if="index == 0" placeholder="请输入商品id" v-model="marketId" clearable>
                            </el-input>

                            <el-input v-if="index == 1" placeholder="请输入商品名称" v-model="marketName" clearable>
                            </el-input>

                            <el-input v-if="index == 2" placeholder="请输入商品编号" v-model="marketSerial" clearable>
                            </el-input>

                            <el-input v-if="index == 3" placeholder="请输入产地" v-model="marketPlace" clearable>
                            </el-input>

                            <el-input v-if="index == 4" placeholder="请输入供应商名称" v-model="marketSupplier" clearable>
                            </el-input>

                            <el-input v-if="index == 5" placeholder="请输入品牌" v-model="marketBrand" clearable>
                            </el-input>

                            <el-select v-if="index == 6" v-model="marketStatusType" placeholder="请选择" clearable
                                :disabled="marketTitleIndex != 0 ? true : false">
                                <el-option v-for="item in marketStatusList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="market-first-bottom">
                    <div class="first-bottom-inquire" @click="marketInquire">查询</div>
                    <div class="first-bottom-reset" @click="marketReset">重置</div>
                </div>
            </div>

            <div class="market-second">
                <div class="market-second-top">
                    <div class="second-top-left">查询结果</div>
                    <div class="second-top-right">
                        <div class="second-top-right-addition" v-if="marketTitleIndex == 2" @click="commodityAddition">
                            <img class="second-top-right-addition-img" src="../../assets/common/common-lvadd.png" />
                            <div class="second-top-right-addition-text">商品添加</div>
                        </div>
                        <div class="second-top-right-undercarriage" v-if="marketTitleIndex == 1"
                            @click="batchUndercarriage">
                            下架
                        </div>
                        <div class="second-top-right-detele" v-if="marketTitleIndex == 2" @click="batchDetele">
                            删除
                        </div>
                        <div class="second-top-right-derive" @click="export2Excel">
                            <img class="derive-img" src="../../assets/common/common-derive.png" />
                            <div class="derive-title">导出商品</div>
                        </div>
                    </div>
                </div>

                <div class="market-second-table">
                    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border=""
                        @selection-change="handleSelectionChange" :header-cell-style="{
                            color: '#333333',
                            backgroundColor: '#FAFAFA',
                        }">
                        <!-- 自定义暂无数据 -->
                        <template slot="empty">
                            <div class="empty-block">
                                <img class="empty-block-img" src="../../assets/common/common-empty.png" />
                                <div class="empty-block-text">暂无数据～</div>
                            </div>
                        </template>
                        <el-table-column type="selection" width="45"></el-table-column>
                        <el-table-column prop="id" label="商品id" width="160">
                        </el-table-column>
                        <el-table-column label="状态" width="84">
                            <template slot-scope="scope">
                                <div :style="{
                                    color:
                                        scope.row.status == 1
                                            ? '#5CDBD3'
                                            : scope.row.status == 2
                                                ? '#CACACA'
                                                : scope.row.status == 3 || scope.row.status == 4
                                                    ? '#F759AB'
                                                    : '',
                                }">
                                    {{
                                        scope.row.status == 1
                                        ? '售卖中'
                                        : scope.row.status == 2
                                            ? '下架中'
                                            : scope.row.status == 3 || scope.row.status == 4
                                                ? '活动中'
                                                : ''
                                    }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="brand" label="品牌" width="134">
                        </el-table-column>
                        <el-table-column label="商品主图" width="99">
                            <template slot-scope="scope">
                                <img class="masterImg" :src="scope.row.image" alt="" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="商品名称" width="228">
                        </el-table-column>
                        <!-- <el-table-column
              prop="goods_one_type_name"
              label="一级分类"
              width="110"
            >
            </el-table-column>
            <el-table-column
              prop="goods_two_type_name"
              label="二级分类"
              width="110"
            >
            </el-table-column> -->
                        <el-table-column prop="chandi" label="产地" width="84">
                        </el-table-column>
                        <el-table-column label="含税成本价(元)" width="140">
                            <template slot-scope="scope">
                                <div>¥&nbsp;{{ scope.row.cost_price }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="不含税成本价(元)" width="160">
                            <template slot-scope="scope">
                                <div>¥&nbsp;{{ scope.row.pure_cost_price }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="use_integral" label="兑换积分" width="110">
                        </el-table-column>
                        <el-table-column label="价格" width="86">
                            <template slot-scope="scope">
                                <div class="table-price" @click="priceExamine(scope.row)">
                                    查看
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sale_num" label="月销量" width="110">
                        </el-table-column>
                        <el-table-column prop="total_sale_num" label="总销量" width="110">
                        </el-table-column>
                        <el-table-column prop="supplier_name" label="供应商名称" width="216">
                        </el-table-column>
                        <el-table-column label="操作" width="180" fixed="right">
                            <template slot-scope="scope">
                                <div class="operation">
                                    <div class="operation-left" @click="editMarket(scope.row)">
                                        {{ scope.row.status == 2 ? '编辑' : '查看' }}
                                    </div>
                                    <div class="operation-center" @click="undercarriageMarket(scope.row)"
                                        v-if="scope.row.status != 2">
                                        下架
                                    </div>
                                    <div class="operation-center" @click="groundingMarket(scope.row)" v-else>
                                        上架
                                    </div>
                                    <div class="operation-right" @click="deteleMarket(scope.row)"
                                        v-if="scope.row.status == 2">
                                        删除
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="market-second-Pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next, sizes" :total="totalNum">
                    </el-pagination>
                </div>
            </div>

            <!-- 商品上下架 -->
            <div class="undercarriage">
                <el-dialog :visible.sync="undercarriageDialogVisible" width="394px" style="margin-top: 10vh">
                    <span slot="footer" class="dialog-footer">
                        <div class="undercarriage-div">
                            <img class="undercarriage-div-img" src="../../assets/common/common-warning.png" />
                            <div class="undercarriage-div-title">
                                {{
                                    groundingisShow == false
                                    ? '确实是否下架该商品？'
                                    : '是否上架该商品？'
                                }}
                            </div>
                            <div class="undercarriage-div-text" v-if="groundingisShow == false">
                                {{
                                    coronaStatus == false
                                    ? '一旦下架成功，该商品进入仓库区。用户不可对该商品进行操作。'
                                    : '该商品为活动中商品，一旦下架成功，该商品进入仓库区，活动中添加的商品将进行删除。用户不可进行操作。'
                                }}
                            </div>

                            <div class="undercarriage-div-text" v-else>
                                一旦上架用户可对该商品进行查看并且购买。
                            </div>
                            <div class="undercarriage-div-button">
                                <div class="undercarriage-div-button-left" @click="undercarriageBtn">
                                    确定
                                </div>
                                <div class="undercarriage-div-button-right" @click="undercarriageClose">
                                    取消
                                </div>
                            </div>
                        </div>
                    </span>
                </el-dialog>
            </div>

            <!-- 删除商品 -->
            <div class="undercarriage">
                <el-dialog :visible.sync="deteleDialogVisible" width="394px" style="margin-top: 10vh">
                    <span slot="footer" class="dialog-footer">
                        <div class="undercarriage-div">
                            <img class="undercarriage-div-img" src="../../assets/common/common-warning.png" />
                            <div class="undercarriage-div-title">是否删除该商品？</div>

                            <div class="undercarriage-div-text">
                                一旦删除该商品的所有信息则进行删除。
                            </div>
                            <div class="undercarriage-div-button">
                                <div class="undercarriage-div-button-left" @click="deteleConfirm">
                                    确定
                                </div>
                                <div class="undercarriage-div-button-right" @click="deteleReset">
                                    取消
                                </div>
                            </div>
                        </div>
                    </span>
                </el-dialog>
            </div>

            <!--价格设置-->
            <div class="priceSet">
                <el-dialog :visible.sync="priceDialogVisible" width="1100px" @close="priceSetBtn">
                    <span slot="footer" class="dialog-footer">
                        <div class="priceSet-div">
                            <div class="priceSet-div-top">
                                <div class="priceSet-div-top-title">价格查看</div>
                                <img class="priceSet-div-top-img" src="../../assets/activities/activities-close.png"
                                    @click="priceSetBtn" />
                            </div>

                            <div class="priceSet-div-center">
                                <el-table :data="priceTable" border tooltip-effect="dark" style="width: 100%"
                                    :header-cell-style="{
                                        color: '#333333',
                                        backgroundColor: '#FAFAFA',
                                    }">
                                    <el-table-column label="规格1">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                {{ scope.row.goods_spec_one_name }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="规格2">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                {{ scope.row.goods_spec_two_name }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="兑换积分" width="120">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                <el-input v-if="priceSetShow == false &&
                                                    scope.$index === updateIndex
                                                    " placeholder="" v-model="scope.row.use_integral">
                                                </el-input>

                                                <span v-else>{{ scope.row.use_integral }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="不含税成本价(元)">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                <el-input v-if="priceSetShow == false &&
                                                    scope.$index === updateIndex
                                                    " placeholder="" v-model="scope.row.pure_cost_price">
                                                </el-input>

                                                <span v-else>{{ scope.row.pure_cost_price }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="含税成本价(元)" width="130">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                <el-input v-if="priceSetShow == false &&
                                                    scope.$index === updateIndex
                                                    " placeholder="" v-model="scope.row.cost_price">
                                                </el-input>
                                                <span v-else>{{ scope.row.cost_price }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column label="获得积分" width="84">
                    <template slot-scope="scope">
                      <div class="table-input">
                        <el-input
                          v-if="
                            priceSetShow == false &&
                            scope.$index === updateIndex
                          "
                          placeholder=""
                          v-model="scope.row.use_integral"
                        >
                        </el-input>

                        <span v-else>{{ scope.row.use_integral }}</span>
                      </div>
                    </template>
                  </el-table-column> -->
                                    <el-table-column label="库存数" width="84">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                <el-input v-if="priceSetShow == false &&
                                                    scope.$index === updateIndex
                                                    " placeholder="" v-model="scope.row.num">
                                                </el-input>

                                                <span v-else>{{ scope.row.num }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="图片" width="80">
                                        <template slot-scope="scope">
                                            <div class="table-upload">
                                                <el-upload v-if="priceSetShow == false" class="upload-img"
                                                    action="https://laravel-api-manager.xmw1688.com/common/upload"
                                                    list-type="picture-card" :on-success="handleSuccess" :limit="1"
                                                    :show-file-list="false" ref="upload">
                                                    <div class="upload-img-block" v-if="priceSetShow == false &&
                                                        scope.$index === updateIndex
                                                        ">
                                                        <img class="table-img" v-if="MasterImg != ''" :src="MasterImg"
                                                            alt="" />

                                                        <img class="table-img" v-else-if="scope.row.image != ''"
                                                            :src="scope.row.image" alt />
                                                        <div class="table-text" v-else>添加</div>
                                                    </div>

                                                    <div class="upload-img-block" v-else>
                                                        <img class="table-img" v-if="scope.row.image != ''"
                                                            :src="scope.row.image" alt="" />
                                                        <div class="table-text" v-else>添加</div>
                                                    </div>
                                                </el-upload>

                                                <div class="upload-img-block" v-else>
                                                    <img class="table-img" v-if="scope.row.image != ''"
                                                        :src="scope.row.image" alt="" />
                                                    <div class="table-text" v-else>添加</div>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="重量(kg)" width="100">
                                        <template slot-scope="scope">
                                            <div class="table-input">
                                                <el-input v-if="priceSetShow == false &&
                                                    scope.$index === updateIndex
                                                    " placeholder="选填" v-model="scope.row.zhongliang">
                                                </el-input>

                                                <span v-else>{{ scope.row.zhongliang }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="操作" width="70">
                                        <template slot-scope="scope">
                                            <div class="table-text" @click="priceSetEdit(scope.$index, scope.row)">
                                                {{
                                                    priceSetShow == false && scope.$index === updateIndex
                                                    ? '保存'
                                                    : '修改'
                                                }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>

                            <div class="priceSet-div-button">
                                <div class="priceSet-div-button-left" @click="priceSetBtn">
                                    关闭
                                </div>
                            </div>
                        </div>
                    </span></el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import Bus from '../../utils/bus'

import {
    getintegralList,
    postintegralTransfer,
    putintegralStand,
    putintegralStandList,
    deletefniIntegral,
    getcommodityClassify,
    getsecondClass,
    postfnintegralList,
    getintegralSkulist,
    postintegralSkulistEdit,
} from '../../api/commodity'

export default {
    data() {
        return {
            // 第一区域 标题数组
            marketTitleArray: ['全部商品', '销售中', '仓库中'],
            // 第一区域 标题数组下标
            marketTitleIndex: 0,
            // 第一区域  商品id
            marketId: '',
            // 第一区域  商品名称
            marketName: '',
            // 第一区域  商品编号
            marketSerial: '',
            // 第一区域  产地
            marketPlace: '',
            // 第一区域  是否为特产
            marketSpecialtyType: '',
            marketSpecialtyList: [
                {
                    value: '0',
                    label: '不是',
                },
                {
                    value: '1',
                    label: '是',
                },
            ],
            // 第一区域  一级分类
            marketStairType: '',
            marketStairList: [],
            // 第一区域  二级分类
            marketSecondType: '',
            marketSecondList: [],
            // 第一区域  供应商名称
            marketSupplier: '',
            // 第一区域  品牌
            marketBrand: '',
            // 第一区域  状态
            marketStatusType: '',
            marketStatusList: [
                {
                    value: '1',
                    label: '售卖中',
                },
                {
                    value: '2',
                    label: '下架中',
                },
            ],
            /*end */
            // 第二区域 表格数组
            tableData: [],
            // 存储表格选中的值
            multipleSelection: [],
            // 表格列表总数
            totalNum: 0,
            // 页码
            page: 1,
            // 页数
            limit: 10,
            // 监听用户刷新
            loading: false,

            // 商品上下架 是否开启
            undercarriageDialogVisible: false,
            // 判断商品是上架还是下架状态
            groundingisShow: false,
            groundingisId: '',
            // 商品上下架判断用户是否是下架是否是 活动商品还是普通商品
            coronaStatus: false,
            // 第二区域点击删除商品
            deteleDialogVisible: false,
            // 判断操作人员是否点击批量删除
            batchDeteleShow: false,
            // 批量下架强制参数
            batchforce: '',

            // 价格设置弹出框
            priceDialogVisible: false,
            // 价格表格区域
            priceTable: [],
            // 价格表格区域 弹出框  当前商品状态
            priceStatus: false,
            // 用户价格设置 点击 修改变成输入框
            priceSetShow: true,
            // 当前表格索引
            updateIndex: 0,
            // 上传的图片
            MasterImg: '',
            // 控制当前页面功能性按钮开关
            commodityFunShow: false,
        }
    },
    created() {
        // 请求商品列表接口
        this.loading = true
        this.getMarketClick()

        setTimeout(() => {
            this.commodityFunShow = this.$store.state.pageFunctionShow
        }, 1000);

    },
    methods: {
        // 获取商品列表接口数据
        getMarketClick() {
            let params = {
                id: this.marketId, // 商品id
                name: this.marketName, // 商品名称
                code: this.marketSerial, // 商品编号
                chandi: this.marketPlace, // 产地
                is_speciality: this.marketSpecialtyType, // 是否为特产  1是
                is_handpick: '', // 是否精选 1是
                goods_one_type_id: this.marketStairType, // 一级分类id
                goods_two_type_id: this.marketSecondType, // 二级分类id
                supplier_name: this.marketSupplier, // 供应商名称
                brand_name: this.marketBrand, // 品牌名称
                status:
                    this.marketStatusType == '1'
                        ? 1
                        : this.marketStatusType == '2'
                            ? 2
                            : this.marketStatusType == '3'
                                ? 30
                                : '', // 状态:1=上架,2=下架 30活动中
                pageSize: this.limit, // 页码
                pageNo: this.page, // 页数
            }

            getintegralList(params).then((res) => {
                if (res.resultStatus == true) {
                    // 获取表格数据
                    this.tableData = res.resultData.goodsList
                    // 获取表格数据总数
                    this.totalNum = res.resultData.totalNum
                    // 关闭刷新
                    this.loading = false
                }
            })
        },

        // 第一区域 点击查询
        marketInquire() {
            this.page = 1
            this.loading = true
            this.getMarketClick()
        },

        // 第一区域 点击重置
        marketReset() {
            this.marketId = ''
            this.marketName = ''
            this.marketSerial = ''
            this.marketPlace = ''
            this.marketSpecialtyType = ''
            this.marketStairType = ''
            this.marketSecondType = ''
            this.marketSupplier = ''
            this.marketBrand = ''
            this.marketStatusType =
                this.marketTitleIndex == 0 ? '' : this.marketStatusType
            this.page = 1

            this.loading = true
            this.getMarketClick()
        },

        // 点击对应分类进行切换
        titleBtn(index) {
            this.marketTitleIndex = index
            this.marketStatusType = index == 1 ? '1' : index == 2 ? '2' : ''
            this.marketId = ''
            this.marketName = ''
            this.marketSerial = ''
            this.marketPlace = ''
            this.marketSpecialtyType = ''
            this.marketStairType = ''
            this.marketSecondType = ''
            this.marketSupplier = ''
            this.marketBrand = ''
            this.page = 1
            this.loading = true
            this.getMarketClick()
        },
        // 表格区域点击选中 勾选对应的
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 第二区域 编辑弹出框
        editMarket(item) {
            if (this.commodityFunShow == false) {
                return
            }

            // index == 0  普通商品  1 积分
            let obj = {
                id: item.id,
                index: 1,
            }
            Bus.$emit('log', 'commodityAdd', obj)
        },

        // 第二区域  商品下架
        undercarriageMarket(item) {
            if (this.commodityFunShow == false) {
                return
            }

            this.groundingisShow = false
            this.groundingisId = item.id
            this.undercarriageDialogVisible = true
        },
        // 第二区域  商品上架 弹出框
        groundingMarket(item) {
            if (this.commodityFunShow == false) {
                return
            }

            this.groundingisShow = true
            this.groundingisId = item.id
            this.undercarriageDialogVisible = true
        },
        // 第二区域  商品上下架点击确定
        undercarriageBtn() {
            if (this.batchforce == 1) {
                this.batchUndercarriage()
            } else {
                let params = this.groundingisId

                putintegralStand(params).then((res) => {
                    if (res.resultStatus == true) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success',
                            duration: 2000,
                        })

                        this.loading = true
                        this.undercarriageDialogVisible = false
                        this.getMarketClick()
                    } else {
                        // this.$message({
                        //   message: res.errorMessage,
                        //   type: 'error',
                        //   duration: 2000,
                        // })
                        this.undercarriageDialogVisible = false
                    }
                })
            }
        },
        // 第二区域  商品上下架点击取消
        undercarriageClose() {
            this.groundingisId = ''
            this.undercarriageDialogVisible = false
        },

        // 第二区域  用户点击添加商品 跳转 商品添加页面
        commodityAddition() {
            if (this.commodityFunShow == false) {
                return
            }

            let item = {
                index: 1,
            }
            Bus.$emit('log', 'commodityAdd', item)
        },
        // 批量删除
        batchDetele() {
            if (this.commodityFunShow == false) {
                return
            }

            this.batchDeteleShow = true
            this.deteleDialogVisible = true
        },

        // 第二区域 用户点击删除商品 弹出框
        deteleMarket(item) {
            if (this.commodityFunShow == false) {
                return
            }
            this.groundingisId = item.id
            this.batchDeteleShow = false
            this.deteleDialogVisible = true
        },

        // 第二区域  删除弹出框 确认
        deteleConfirm() {
            if (this.batchDeteleShow == false) {
                let params = this.groundingisId

                deletefniIntegral(params).then((res) => {
                    if (res.resultStatus == true) {
                        this.$message({
                            message: '删除成功！',
                            type: 'success',
                            duration: 2000,
                        })

                        this.loading = true
                        this.deteleDialogVisible = false
                        this.batchDeteleShow = false
                        this.getMarketClick()

                        this.groundingisId = ''
                    } else {
                        // this.$message({
                        //   message: res.errorMessage,
                        //   type: 'error',
                        //   duration: 2000,
                        // })
                        this.groundingisId = ''
                        this.batchDeteleShow = false
                        this.deteleDialogVisible = false
                    }
                })
            } else {
                let commodityIds = this.multipleSelection
                    .map((item) => {
                        return item.id
                    })
                    .join(';')

                let params = {
                    ids: commodityIds, // 商品id ;隔开
                }

                console.log('批量删除', params)

                postfnintegralList(params).then((res) => {
                    if (res.resultStatus == true) {
                        this.$message({
                            message: '删除成功！',
                            type: 'success',
                            duration: 2000,
                        })

                        this.loading = true
                        this.deteleDialogVisible = false
                        this.batchDeteleShow = false
                        this.multipleSelection = []
                        this.getMarketClick()

                        this.groundingisId = ''
                    } else {
                        // this.$message({
                        //   message: res.errorMessage,
                        //   type: 'error',
                        //   duration: 2000,
                        // })
                        this.groundingisId = ''
                        this.batchDeteleShow = false
                        this.deteleDialogVisible = false
                    }
                })
            }
        },
        // 第二区域  删除弹出框 取消
        deteleReset() {
            this.groundingisId = ''
            this.batchDeteleShow = false
            this.deteleDialogVisible = false
        },

        // 第二区域  批量下架
        batchUndercarriage() {
            if (this.commodityFunShow == false) {
                return
            }

            let commodityIds = this.multipleSelection
                .map((item) => {
                    return item.id
                })
                .join(';')

            let params = {
                ids: commodityIds,
                force: this.batchforce,
            }

            putintegralStandList(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: '下架成功！',
                        type: 'success',
                        duration: 2000,
                    })
                    this.loading = true
                    this.multipleSelection = []
                    this.getMarketClick()
                } else if (
                    res.errorCode == 30021 ||
                    res.errorCode == 30022 ||
                    res.errorCode == 30023
                ) {
                    this.undercarriageDialogVisible = true
                    this.batchforce = 1
                }
            })
        },

        // 价格设置弹出框 开启
        priceExamine(item) {
            if (this.commodityFunShow == false) {
                return
            }

            if (item.status) {
                // 判断当前商品的状态 true  下架  false 售卖  或者 活动
                this.priceStatus = item.status == 2 ? true : false
            }

            console.log('用户规格数组', item)

            console.log(
                '-----------------------------------------------',
                this.priceStatus
            )

            let params = {
                id: item.id,
            }
            // 获取当前商品的规格
            getintegralSkulist(params).then((res) => {
                console.log('规格对象', res)
                if (res.resultStatus == true) {
                    this.priceTable = res.resultData.goodsStockList
                    this.priceSetShow = true
                    this.priceDialogVisible = true
                }
            })
        },

        // 用户设置价格点击修改
        priceSetEdit(index, item) {
            console.log('当前点击的数据', index, item)

            console.log('查询点击', this.priceStatus)

            if (this.priceStatus == false) {
                this.$message({
                    message: '需商品下架才可进行编辑！',
                    type: 'error',
                    duration: 2000,
                })
                return
            }

            this.priceSetShow = !this.priceSetShow
            this.updateIndex = index

            console.log('点击一次', this.priceSetShow)

            if (this.priceSetShow == true) {
                let params = {
                    id: item.id, // 当前规格id
                    num: item.num, //  库存数
                    pure_cost_price: item.pure_cost_price, // 不含税成本价
                    cost_price: item.cost_price, // 成本价
                    use_integral: item.use_integral, // 需要的积分
                    image: this.MasterImg == '' ? item.image : this.MasterImg, // 商品图片
                    zhongliang: item.zhongliang, // 重量
                }

                postintegralSkulistEdit(params).then((res) => {
                    if (res.resultStatus == true) {
                        // 用户填写
                        this.$message({
                            message: '修改成功！',
                            type: 'success',
                            duration: 2000,
                        })

                        item.id = item.goods_integral_id
                        this.priceExamine(item)
                    }
                })
            }
        },

        // 积分商品导出
        export2Excel() {
            if (this.commodityFunShow == false) {
                return
            }

            this.loading = true

            let commodityIds = ''

            if (this.multipleSelection.length == 0) {
                commodityIds = this.marketId
            } else {
                commodityIds = this.multipleSelection
                    .map((item) => {
                        return item.id
                    })
                    .join(';')
            }

            let codeStatus =
                this.marketStatusType == '1'
                    ? 1
                    : this.marketStatusType == '2'
                        ? 2
                        : this.marketStatusType == '3'
                            ? 30
                            : ''
            // -------------------------------------------------

            let Url =
                'https://laravel-api-manager.xmw1688.com/v1/manager/integral/good?excel=' +
                1 +
                '&ids=' +
                commodityIds +
                '&name=' +
                this.marketName +
                '&code=' +
                this.marketSerial +
                '&chandi=' +
                this.marketPlace +
                '&is_speciality=' +
                this.marketSpecialtyType +
                '&is_handpick=' +
                '' +
                '&goods_one_type_id=' +
                this.marketStairType +
                '&goods_two_type_id=' +
                this.marketSecondType +
                '&supplier_name=' +
                this.marketSupplier +
                '&brand_name=' +
                this.marketBrand +
                '&status=' +
                codeStatus +
                '&accessToken=' +
                localStorage.getItem('token')

            window.location.href = Url

            console.log('查看参数', Url)

            this.loading = false
        },

        // 价格设置弹出框 关闭
        priceSetBtn() {
            this.priceDialogVisible = false
            this.loading = true
            console.log('查询')
            this.getMarketClick()
        },

        handleSuccess(file, fileList) {
            this.$refs.upload.clearFiles()
            this.MasterImg = file.resultData
        },
        masterDetele() {
            this.MasterImg = ''
        },

        //  查询当前页码多少条
        handleSizeChange(val) {
            this.limit = val
            this.loading = true
            this.getMarketClick()
            console.log(`每页 ${val} 条`)
        },
        //  查询当前页
        handleCurrentChange(val) {
            this.page = val
            this.loading = true
            this.getMarketClick()
            console.log(`当前页: ${val}`)
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

.market {
    .market-block {
        .market-first {
            background: #ffffff;
            box-shadow: 0px 0px 10px 0px #edeff7;
            border-radius: 10px;
            padding: 0 24px;
            padding-bottom: 24px;
            box-sizing: border-box;

            .market-first-top {
                display: flex;
                height: 55px;
                border-bottom: 1px solid #f4f5f9;

                .top-list {
                    height: 55px;
                    position: relative;
                    margin-right: 30px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .top-list-title {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                    }

                    .top-list-lint {
                        position: absolute;
                        bottom: 0;
                        width: 56px;
                        height: 4px;
                        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                        border-radius: 15px 15px 0px 0px;
                    }
                }

                .active {
                    .top-list-title {
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 600;
                        color: #222222;
                    }
                }
            }

            .market-first-center {
                display: flex;
                margin-top: 30px;

                .first-center-list {
                    margin-right: 22px;

                    .first-center-list-title {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                    }

                    .first-center-list-input {
                        width: 100%;
                        margin-top: 4px;

                        /deep/ .el-input {
                            height: 32px;
                            width: 180px;
                        }

                        /deep/ .el-input__inner {
                            padding: 0 10px;
                            box-sizing: border-box;
                            height: 32px;
                            background-color: rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-select .el-input.is-focus .el-input__inner {
                            border-color: rgba(217, 217, 217, 1);
                        }

                        /deep/ .el-range-editor.el-input__inner {
                            padding: 0;
                            padding: 0 12px;
                            box-sizing: border-box;
                        }

                        /deep/ .el-date-editor--daterange.el-input__inner {
                            width: 100%;
                        }

                        /deep/ .el-date-editor .el-range-separator {
                            width: 26px;
                            padding: 0;
                            height: 32px;
                            line-height: 32px;
                            background-image: url('../../assets/activities/activities-right.png');
                            background-repeat: no-repeat;
                            background-position: center;
                        }
                    }
                }

                .first-center-list:last-child {
                    margin-right: 0;
                }
            }

            .market-first-bottom {
                display: flex;
                margin-top: 27px;

                .first-bottom-inquire,
                .first-bottom-reset {
                    width: 110px;
                    height: 36px;
                    background: #222222;
                    border-radius: 10px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    cursor: pointer;
                }

                .first-bottom-reset {
                    background: #f4f5f9;
                    margin-left: 10px;
                    color: #999999;
                }
            }
        }

        .market-second {
            margin-top: 24px;
            background: #ffffff;
            padding: 0 24px;
            box-sizing: border-box;

            .market-second-top {
                width: 100%;
                height: 68px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .second-top-left {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #222222;
                }

                .second-top-right {
                    display: flex;

                    .second-top-right-addition {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                        width: 110px;
                        height: 36px;
                        border-radius: 10px;
                        border: 1px solid #36c100;
                        cursor: pointer;

                        .second-top-right-addition-img {
                            width: 13px;
                            height: 13px;
                            margin-right: 8px;
                        }

                        .second-top-right-addition-text {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #36c100;
                        }
                    }

                    .second-top-right-undercarriage {
                        width: 60px;
                        height: 36px;
                        border-radius: 10px;
                        border: 1px solid #ed6d1f;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ed6d1f;
                        text-align: center;
                        cursor: pointer;
                        line-height: 36px;
                        margin-right: 10px;
                    }

                    .second-top-right-refresh {
                        width: 88px;
                        height: 36px;
                        border-radius: 10px;
                        border: 1px solid #36c100;
                        text-align: center;
                        line-height: 36px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #36c100;
                        cursor: pointer;
                    }

                    .second-top-right-detele {
                        width: 60px;
                        height: 36px;
                        background: #555555;
                        border-radius: 10px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                        text-align: center;
                        cursor: pointer;
                        margin-left: 10px;
                        line-height: 36px;
                    }

                    .second-top-right-derive {
                        display: flex;
                        height: 36px;
                        align-items: center;
                        justify-content: center;
                        width: 110px;
                        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                        border-radius: 10px;
                        margin-left: 10px;
                        cursor: pointer;

                        .derive-img {
                            width: 12px;
                            height: 12px;
                            margin-right: 5px;
                        }

                        .derive-title {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #ffffff;
                        }
                    }
                }
            }

            .market-second-table {
                /deep/ .el-table thead {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    background: #d8d8d8;
                }

                /deep/ .el-table tr {
                    height: 46px;
                }

                /deep/ .el-table__empty-text {
                    line-height: 0;
                }

                .empty-block {
                    margin-top: 62px;
                    padding-bottom: 40px;

                    .empty-block-img {
                        width: 130px;
                        height: 130px;
                        margin: 0 auto;
                    }

                    .empty-block-text {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        margin-top: 10px;
                        height: 17px;
                        line-height: 17px;
                    }
                }

                .masterImg {
                    width: 70px;
                    height: 70px;
                }

                .table-price {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2aa4ff;
                    text-decoration: underline;
                    cursor: pointer;
                }

                .operation {
                    display: flex;

                    .operation-left,
                    .operation-right,
                    .operation-center {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #2aa4ff;
                        text-decoration: underline;
                        cursor: pointer;
                    }

                    .operation-right,
                    .operation-center {
                        margin-left: 24px;
                    }
                }
            }

            .market-second-Pagination {
                height: 88px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                /deep/ .el-pagination .btn-prev {
                    padding: 0;
                    width: 32px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 2px;
                    border: 1px solid #d9d9d9;
                    margin-right: 8px;
                }

                /deep/ .el-pagination .btn-next {
                    padding: 0;
                    width: 32px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 2px;
                    border: 1px solid #d9d9d9;
                }

                /deep/ .el-pager li {
                    padding: 0;
                    width: 32px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 2px;
                    border: 1px solid #d9d9d9;
                    line-height: 32px;
                    margin-right: 8px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);
                }

                /deep/ .el-pager li.active {
                    background: #000000;
                    color: #ffffff;
                }

                /deep/ .el-input--mini .el-input__inner {
                    height: 32px;
                }

                /deep/ .el-input__inner {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }

        // 商品上下架
        .undercarriage {
            /deep/ .el-dialog {
                height: 231px;
            }

            /deep/ .el-dialog__footer {
                padding: 25px 12px;
                box-sizing: border-box;
            }

            .undercarriage-div {
                width: 100%;
                text-align: center;

                .undercarriage-div-img {
                    width: 56px;
                    height: 56px;
                    margin: 0 auto;
                }

                .undercarriage-div-title {
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.85);
                    margin-top: 8px;
                }

                .undercarriage-div-text {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.45);
                    margin-top: 2px;
                }

                .undercarriage-div-button {
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    margin-top: 18px;

                    .undercarriage-div-button-left,
                    .undercarriage-div-button-right {
                        width: 88px;
                        height: 32px;
                        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                        border-radius: 10px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                        cursor: pointer;
                    }

                    .undercarriage-div-button-right {
                        margin-left: 8px;
                        border: 1px solid #e9edf4;
                        color: rgba(0, 0, 0, 0.65);
                        background: #ffffff;
                    }
                }
            }
        }

        // 价格设置弹出框
        .priceSet {
            /deep/ .el-dialog {
                background: #ffffff;
            }

            /deep/ .el-dialog__footer {
                padding: 0;
                box-sizing: border-box;
            }

            .priceSet-div {
                width: 100%;
                background: #fff;

                .priceSet-div-top {
                    display: flex;
                    height: 55px;
                    align-items: center;
                    padding: 0 24px;
                    box-sizing: border-box;
                    justify-content: space-between;
                    border-bottom: 1px solid #d9d9d9;

                    .priceSet-div-top-title {
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #222222;
                    }

                    .priceSet-div-top-img {
                        width: 10px;
                        height: 10px;
                        cursor: pointer;
                    }
                }

                .priceSet-div-center {
                    padding: 0 24px;
                    padding-top: 20px;
                    box-sizing: border-box;

                    /deep/ .el-table .el-table__cell {
                        padding: 0;
                        text-align: center;
                    }

                    /deep/ .el-table thead {
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        background: #d8d8d8;
                    }

                    /deep/ .el-table tr {
                        height: 46px;
                    }

                    .table-input {
                        /deep/ .el-input {
                            height: 32px;
                        }

                        /deep/ .el-input__inner {
                            padding: 0 10px;
                            box-sizing: border-box;
                            height: 32px;
                            background-color: rgba(255, 255, 255, 0);
                        }
                    }

                    .table-upload {
                        width: 50px;
                        height: 50px;
                        cursor: pointer;
                        position: relative;
                        margin: 0 auto;

                        .upload-img {
                            width: 50px;
                            height: 50px;
                            position: relative;

                            /deep/ .el-upload--picture-card {
                                width: 50px;
                                height: 50px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: 1px solid rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-upload--picture-card:hover {
                                border-color: rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-upload-list--picture-card .el-upload-list__item {
                                width: 50px;
                                height: 50px;
                                margin: 0;
                            }

                            .upload-img-block {
                                width: 50px;
                                height: 50px;
                                position: relative;
                                display: flex;
                                justify-content: center;
                                align-items: center;

                                .table-img {
                                    width: 50px;
                                    height: 50px;
                                    position: absolute;
                                    top: 0;
                                    display: flex;
                                }
                            }
                        }
                    }

                    .upload-img-block {
                        width: 50px;
                        height: 50px;
                        position: relative;
                        display: flex;
                        align-items: center;

                        .table-img {
                            width: 50px;
                            height: 50px;
                            position: absolute;
                            top: 0;
                        }
                    }

                    .table-text {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #2aa4ff;
                        text-decoration: underline;
                        cursor: pointer;
                    }

                    .table-img {
                        width: 50px;
                        height: 50px;
                    }
                }

                .priceSet-div-button {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    height: 52px;
                    margin-top: 20px;
                    border-top: 1px solid #d9d9d9;
                    padding: 0 24px;
                    box-sizing: border-box;

                    .priceSet-div-button-left,
                    .priceSet-div-button-right {
                        width: 65px;
                        height: 32px;
                        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                        border-radius: 10px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                        cursor: pointer;
                    }

                    .priceSet-div-button-right {
                        margin-left: 8px;
                        border: 1px solid #e9edf4;
                        color: rgba(0, 0, 0, 0.65);
                        background: #ffffff;
                    }

                    .priceSet-div-button-left {
                        margin-left: 8px;
                    }
                }
            }
        }
    }

    .market-layer {
        width: 100%;
        height: 88vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;

        .market-layer-img {
            width: 200px;
            height: 200px;
            border: 1px solid;
        }
    }
}
</style>
